import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import axios from 'axios';
export const formatPhone = (phone) => {
  if (!phone) return "-";

  // Sadece rakamları al
  let digits = phone.toString().replace(/\D/g, "");

  // +90 ile gelenler (90555...)
  if (digits.startsWith("90") && digits.length === 12) {
    return `+90 (${digits.slice(2, 5)}) ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
  }

  // 0 ile başlayanlar (0555...)
  if (digits.startsWith("0") && digits.length === 11) {
    return `0 (${digits.slice(1, 4)}) ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`;
  }

  // Direkt 5 ile başlayanlar (555...)
  if (digits.startsWith("5") && digits.length === 10) {
    return `0 (${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`;
  }

  // Diğer ülke kodları (+49123...)
  if (digits.length > 11) {
    const countryCode = digits.slice(0, digits.length - 10);
    const number = digits.slice(-10);
    return `+${countryCode} (${number.slice(0, 3)}) ${number.slice(3, 6)} ${number.slice(6, 8)} ${number.slice(8, 10)}`;
  }

  return phone; // fallback
};

const Profile = () => {
    const { id } = useParams();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem("admin_token");
                if (!token) {
                    setError("Yetkilendirme hatası: Kullanıcı giriş yapmamış!");
                    setLoading(false);
                    return;
                }

                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/customers/view/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setUserData(response.data);
            } catch (err) {
                console.error("❌ Kullanıcı bilgileri alınamadı:", err);
                setError("Kullanıcı bilgileri alınamadı.");
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [id]);

    if (loading) return <p>⏳ Yükleniyor...</p>;
    if (error) return <p className="text-danger">{error}</p>;

    //  Eğer profil resmi yoksa varsayılan "/images/avatar/default.svg" atanıyor
    const profileImageUrl = userData.profileImage && userData.profileImage.trim() !== "" 
        ? userData.profileImage 
        : `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg`;

    return (
        <div className="card stretch stretch-full">
            <div className="card-body">
                <div className="mb-4 text-center">
                    <div className="wd-150 ht-150 mx-auto mb-3 position-relative">
                        <div className="avatar-image wd-150 ht-150 border border-5 border-gray-3">
                            <img 
                                src={profileImageUrl} 
                                alt="Profil Resmi" 
                                className="img-fluid rounded-circle"
                                onError={(e) => (e.target.src = `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg`)}// Bozuk link olursa default.svg'ye dön
                                style={{ width: "150px", height: "150px", objectFit: "cover"}} 
                            />
                        </div>
                    </div>
                    <div className="mb-4">
                        <a href="#" className="fs-14 fw-bold d-block">{userData.firstName} {userData.lastName}</a>
                        <a href="#" className="fs-12 fw-normal text-muted d-block">{userData.email}</a>
                    </div>
                </div>
                <ul className="list-unstyled mb-4">
                    <li className="hstack justify-content-between mb-4">
                        <span className="text-muted fw-medium hstack gap-3"><FiMapPin size={16} />Ülke</span>
                        <a href="#" className="float-end">{userData.country || 'Bilinmiyor'}</a>
                    </li>
                    <li className="hstack justify-content-between mb-4">
                        <span className="text-muted fw-medium hstack gap-3"><FiPhone size={16} />Telefon</span>
                        <a href="#" className="float-end">{userData.phone ? formatPhone(userData.phone) : "Bilinmiyor"}</a>
                    </li>
                    <li className="hstack justify-content-between mb-0">
                        <span className="text-muted fw-medium hstack gap-3"><FiMail size={16} />E-Posta</span>
                        <a href="#" className="float-end">{userData.email}</a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Profile;
